import { Component } from 'react';
import { connect } from 'react-redux';

import { createShortUrl } from '../actions/ShortUrlActions';

import { Button, Heading, Pane } from 'evergreen-ui';
import InfoBlock from '../../common/InfoBlock/InfoBlock';

import { Link } from 'react-router-dom';
import ShortUrlForm from '../components/ShortUrlForm';

import Configuration from '../Config';

const validation = Configuration.Validations.shortUrl;
const defaultValues = Configuration.Defaults.createShortUrl;
const mapValidationErrors = Configuration.ErrorHandler.mapValidationErrors;

class CreateShortUrl extends Component {

    componentDidMount() {

    }

    handleSave = (values) => {
        this.props.dispatch(createShortUrl(values));
    }

    render() {
        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex">
                    <Pane>
                        <Link to="/short-urls">
                            <Button iconBefore="arrow-left" intent="none">
                                Inapoi la lista short URLs
                            </Button>
                        </Link>
                    </Pane>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}>
                    <Heading size={600}>
                        Short URL nou
                    </Heading>
                </Pane>

                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <InfoBlock flex="1">
                        <ShortUrlForm
                            isEdit={false}
                            initialValues={defaultValues}
                            validationSchema={validation}
                            onSave={this.handleSave}
                            errors={this.props.errors}/>
                    </InfoBlock>
                </Pane>

            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        errors: state.shortUrls.errors.type === 'validation' ? mapValidationErrors(state.shortUrls.errors.fields): [],
    }
}

export default connect(mapStateToProps)(CreateShortUrl);
